module.exports = __webpack_public_path__ + "static/media/icon-paper-download-white.09e50940.svg";